<template>
    <div class="flex min-h-screen ">
        <!-- Levá strana -->
        <div class="flex flex-col justify-center px-8 lg:px-16 w-full py-8 transition-all bg-white relative dark:bg-black" :class="wide ? 'lg:w-3/4' : 'lg:w-1/2'">
            <div class="w-full mx-auto space-y-6" :class="wide ? '' : 'max-w-md'">

                <!-- Logo -->
                <div class="flex mb-8">
                    <div class="bg-light-logo dark:bg-dark-logo bg-no-repeat bg-contain w-48 h-12"></div>
                </div>

                    <slot v-if="!loading"></slot>
                    <div v-else class="spinner">
                        <ProgressSpinner/>
                    </div>


                <!-- Spodní poznámka -->
                <p class="text-xs text-gray-400 text-center mt-6" v-if="showLegal">
                    © MAEUM {{ new Date().getFullYear() }} – Roori využívá MAEUM Account
                </p>
            </div>
        </div>
        <!-- Pravá strana -->
        <div class="hidden lg:flex flex-col transition-all justify-center items-center bg-center bg-cover" :class="[wide ? ' w-1/4 max-w-1/4' : ' w-1/2 max-w-1/2', bgImage ? `bg-${bgImage}` : 'bg-roori-login-bg']">
            <div v-if="!bgImage" class="max-w-[380px] px-4">
                <login-blog-post v-if="articles[0]" :article="articles[0]"/>
            </div>
            <div v-else class="bg-login-overlay w-full h-full backdrop-blur"></div>
        </div>
    </div>
</template>
<script setup>
import {
    onBeforeMount,
    ref
} from 'vue';
import LoginBlogPost from "../../../administration/components/ui-components/LoginBlogPost.vue";
import {ProgressSpinner} from "primevue";
import {usePage} from "@inertiajs/vue3";
defineProps({
    showLegal: Boolean,
    loading: Boolean,
    wide: Boolean,
    bgImage: String
})

const isLoading = ref(true)
const articles = ref([])
const parnassusUrl = usePage().props.olympus.parnassus_url;

onBeforeMount(() => {
    const endpoint = `blog`;
    axios.get(parnassusUrl + endpoint, {}).then(response => {
        articles.value = response.data;
        isLoading.value = false;
    })
});


</script>
<style lang="scss" scoped>
.login-view {
    transform: scale(0.9);
    pointer-events: none;
    opacity: 0;
    transition: all .3s ease-in-out;
}

.active {
    bottom: 0;
    pointer-events: all;
    opacity: 1;
    transform: scale(1);
}

.login-form {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.height-fade-enter-active,
.height-fade-leave-active {
    transition: all 0.3s ease;
}

.height-fade-enter-from,
.height-fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}
</style>
